export default __webpack_public_path__ + "static/media/pdv_2.43c5bbd6.png";